import {Component, EventEmitter, Input, Output} from '@angular/core';
import {isNullOrUndefined} from 'util';
export class PickListComponent {
   textLabel: string;
   list: Array<any>;
   placeHolder: string;
   headerConfig: any;
   position:string;
   onTransaction = new EventEmitter<any>();


  items: Array<any>;

  header: Array<any>;

  filter:string;

  filterBy:string;

  iconsDirection: string;
constructor(){
  }
private dispatchTransaction = (notMove, toMove)=>{

    this.onTransaction.emit({
      notMove:notMove.map((i=>{
        let { isSelected, ...rest } = i;
        return rest;
      })),
      toMove:toMove.map((i=>{
        let { isSelected, ...rest } = i;
        return rest;
      }))
    })

  };
/**
 * @return {?}
 */
ngOnInit(){
    this.iconsDirection = 'glyphicon glyphicon-arrow-'+this.position;
    this.items = [...this.list.map(it=>{return{...it, isSelected:false} })];
    this.header = [...this.headerConfig].filter(i=>!i.hidden || isNullOrUndefined(i.hidden));

    this.filterBy  = this.header[0].key;

  }
/**
 * @param {?} objChange
 * @return {?}
 */
ngOnChanges(objChange){
    if(objChange.list)
      this.items = [...objChange.list.currentValue];

    if(objChange.headerConfig)
      this.header = [...objChange.headerConfig.currentValue].filter(i=>!i.hidden || isNullOrUndefined(i.hidden));

    if(objChange.filterBy)
      this.filterBy  = objChange.filterBy.currentValue;
  }
/**
 * @return {?}
 */
moveAll(){
    this.dispatchTransaction([], this.items);
  }
/**
 * @return {?}
 */
moveJustSelected(){
    this.dispatchTransaction(this.items.filter(it=>!it.isSelected), this.items.filter(it=>it.isSelected));
  }
/**
 * @param {?} field
 * @return {?}
 */
setFilterBy(field){
    this.filterBy = field;
  }
/**
 * @return {?}
 */
transact(){
    this.dispatchTransaction(this.items,[])
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-pick-list',
  template: `
    <div>
      <label>{{textLabel ? textLabel: 'Not Selected'}}</label>
      <div class="form-group input-icon-right" style="margin-bottom: 0px">
        <i class="glyphicon glyphicon-search"></i>
        <input type="text"
               class="form-control"
               [(ngModel)]="filter"
               placeholder="{{placeHolder ? placeHolder :'Search'}}">
      </div>

      <div class="btn-group buttons">

        <button *ngIf="position==='right'" type="button" class="btn moveall btn-default" title="Move all" (click)="moveAll()"><i class="{{iconsDirection}}"></i> <i class="{{iconsDirection}}"></i></button>
        <button *ngIf="position==='right'" type="button" class="btn move btn-default" style="margin-left: 0" title="Move selected" (click)="moveJustSelected()"><i class="{{iconsDirection}}"></i></button>

        <button *ngIf="position==='left'" type="button" class="btn move btn-default" style="margin-left: 0" title="Move selected" (click)="moveJustSelected()"><i class="{{iconsDirection}}"></i></button>
        <button *ngIf="position==='left'" type="button" class="btn moveall btn-default" title="Move all" (click)="moveAll()"><i class="{{iconsDirection}}"></i> <i class="{{iconsDirection}}"></i></button>

      </div>

      <div style="overflow: scroll; height: 192px" >
        <table class="table table-bordered" >
          <thead>
          <tr>
            <th *ngFor="let h of header" class="text-left" (click)="setFilterBy(h.key)" [ngClass]="{'filter-by': filterBy === h.key}">{{h.text}}</th>
          </tr>
          </thead>
          <tbody class="text-left">
          <tr *ngFor="let itemList of items | searchfilterDualPickList : filterBy : filter" (click)="itemList.isSelected = !itemList.isSelected" [ngClass]="{'dl-selected':itemList.isSelected}">
            <td *ngFor="let l of header |  searchfilterDualPickList : 'hidden' : false " class="text-left">
              <span *ngIf="!l.custom">{{itemList[l.key]}}</span>
              <select *ngIf="l.select" class="form-control" name="{{'selectLeft'+'-'+index}}" id="selectLeft+'-'+index" [(ngModel)]="itemList[l.key]" style="height: inherit;" (ngChange)="transact()">
                <option *ngFor="let item of l.select.list" value="{{item.id}}">{{item.text}}</option>
              </select>
              <input *ngIf="l.checkbox" type="checkbox" [(ngModel)]="itemList[l.key]" (change)="transact()">
              <button *ngIf="l.button" class="btn btn-default" (click)="l.button.onClick(itemList)">{{l.text}}</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
  `,
  styles: [`
    .dl-selected{
      background: #efefef !important;
    }

    .filter-by{
      background: #eee !important;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'textLabel': [{ type: Input },],
'list': [{ type: Input },],
'placeHolder': [{ type: Input },],
'headerConfig': [{ type: Input },],
'position': [{ type: Input },],
'onTransaction': [{ type: Output },],
};
}

function PickListComponent_tsickle_Closure_declarations() {
/** @type {?} */
PickListComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PickListComponent.ctorParameters;
/** @type {?} */
PickListComponent.propDecorators;
/** @type {?} */
PickListComponent.prototype.textLabel;
/** @type {?} */
PickListComponent.prototype.list;
/** @type {?} */
PickListComponent.prototype.placeHolder;
/** @type {?} */
PickListComponent.prototype.headerConfig;
/** @type {?} */
PickListComponent.prototype.position;
/** @type {?} */
PickListComponent.prototype.onTransaction;
/** @type {?} */
PickListComponent.prototype.items;
/** @type {?} */
PickListComponent.prototype.header;
/** @type {?} */
PickListComponent.prototype.filter;
/** @type {?} */
PickListComponent.prototype.filterBy;
/** @type {?} */
PickListComponent.prototype.iconsDirection;
/** @type {?} */
PickListComponent.prototype.dispatchTransaction;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
